













import Vue, { PropType } from 'vue';
import SearchCard, { CardInfo } from '@/components/SearchCard/SearchCard.vue';
import { Campus } from '@/store/modules/location/state';

export default Vue.extend({
  components: {
    SearchCard,
  },
  props: {
    campuses: {
      type: Array as PropType<Campus[]>,
      required: true,
    },
    selectedCampus: {
      type: Number,
      default: -1,
    },
  },
  computed: {
    items(): CardInfo[] {
      const items = this.campuses.map(campus => {
        return {
          key: campus.id,
          content: {
            title: campus.name,
            data: [{ text: campus.address, description: campus.neighborhood }],
            hasInfo: true,
          },
        } as CardInfo;
      });

      return items;
    },
  },
  methods: {
    infoHandler({ key }: CardInfo) {
      const selectedCampus = this.campuses.find(campus => campus.id === key);

      this.$emit('info', selectedCampus);
    },
    selectedHandler({ key }: CardInfo) {
      const selectedCampus = this.campuses.find(campus => campus.id === key);

      setTimeout(() => {
        this.$emit('selected', selectedCampus);
      }, 300);
    },
  },
});
